import { getCourseAttendanceStatus, getCourseStatus } from '../app/scheduleModel';
import type { Course, Room } from '../app/types';
import { DropdownMenu, type DropdownMenuItem } from '../../../../../components/ui/DropdownMenu';

interface CourseTimelineProps {
  room?: Room;
  courses: Course[];
  now: Date;
  onAction: (course: Course, action: DropdownMenuItem) => void;
}

const completedCourseActions: readonly DropdownMenuItem[] = [
  { id: 'makeup-attendance', label: '补点名' },
  { id: 'add-student', label: '添加学员' },
  { id: 'remove-student', label: '移除学员' },
  { id: 'cancel-course', label: '取消', separatorBefore: true },
  { id: 'delete-course', label: '删除' },
];

const activeCourseActions: readonly DropdownMenuItem[] = [
  { id: 'early-attendance', label: '提前点名' },
  { id: 'add-student', label: '添加学员' },
  { id: 'remove-student', label: '移除学员' },
  { id: 'cancel-course', label: '取消', separatorBefore: true },
  { id: 'delete-course', label: '删除' },
];

function getTime(value: string): string {
  return value.slice(11, 16);
}

export function CourseTimeline({ room, courses, now, onAction }: CourseTimelineProps) {
  if (!room) return <section className="schedule-empty">请选择教室查看今日课表</section>;

  return (
    <section className="course-timeline">
      <div className="panel-title-row course-timeline__title">
        <h2 aria-label={`${room.name} 课表`}>{room.name} 课表 <small>{courses.length}节课</small></h2>
      </div>
      {courses.length === 0 ? (
        <div className="schedule-empty schedule-empty--room">
          <img
            className="schedule-empty__illustration"
            src="./assets/teacher-schedule/empty-classroom.png"
            alt=""
            aria-hidden="true"
          />
          <span>该教室今日无课</span>
        </div>
      ) : null}
      <ol className="timeline-list">
        {courses.map((course) => {
          const status = getCourseStatus(course.startTime, course.endTime, now);
          const attendanceStatus = getCourseAttendanceStatus(course, now);
          const actions = status === 'past' ? completedCourseActions : activeCourseActions;
          const attendanceLabel = attendanceStatus === 'attended'
            ? '已点名'
            : attendanceStatus === 'overdue-unattended'
              ? '超时-未点名'
              : attendanceStatus === 'current-unattended'
                ? '上课中-未点名'
                : '待上课-未点名';
          return (
            <li key={course.id} className={`course-card course-card--${status}`}>
              <div className="course-time"><strong>{getTime(course.startTime)}</strong><span>{getTime(course.endTime)}</span></div>
              <i className="timeline-dot" aria-hidden="true" />
              <article>
                <div className="course-card__details">
                  <div className="course-card__heading"><h3>{course.name}</h3><span>{Math.round((new Date(course.endTime).getTime() - new Date(course.startTime).getTime()) / 60000)}分钟</span></div>
                  <p>任课老师：{course.teacherName}  助教：{course.assistantName}  班主任：{course.headTeacherName}</p>
                </div>
                <div className="course-card__controls">
                  <div className="course-actions">
                    <DropdownMenu
                      ariaLabel={`${course.name}操作`}
                      items={actions}
                      trigger={<button type="button" className="secondary-button">操作</button>}
                      onItemSelect={(action) => onAction(course, action)}
                    />
                  </div>
                  <p className={`course-card__attendance course-card__attendance--${attendanceStatus}`}>
                    {attendanceLabel}：{course.attendanceCount}/{course.studentCount} 人
                  </p>
                </div>
              </article>
            </li>
          );
        })}
      </ol>
    </section>
  );
}
